"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ImageUploader = _interopRequireDefault(require("../category/ImageUploader"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _ColorSelector = _interopRequireDefault(require("./ColorSelector"));

var _LogoImageControls = _interopRequireDefault(require("./LogoImageControls"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaultHeader = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DefaultHeader, _Component);

  var _super = _createSuper(DefaultHeader);

  function DefaultHeader() {
    var _this;

    (0, _classCallCheck2.default)(this, DefaultHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      // eslint-disable-next-line react/no-unused-state
      logoUrl: ''
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "uploader", null);
    return _this;
  }

  (0, _createClass2.default)(DefaultHeader, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          logoUrl = _this$props.logoUrl,
          label = _this$props.label,
          labelMobile = _this$props.labelMobile,
          url = _this$props.url,
          backgroundColor = _this$props.backgroundColor,
          linkColor = _this$props.linkColor,
          _onChange = _this$props.onChange;
      return (0, _preact.h)("div", {
        className: "default-header"
      }, (0, _preact.h)("strong", null, "Logo"), (0, _preact.h)("div", null, "Upload your community logo in .PNG or .JPG format here"), (0, _preact.h)("div", {
        className: "default-header_logo-image"
      }, (0, _preact.h)(_LogoImageControls.default, {
        logoUrl: logoUrl,
        onClick: function onClick() {
          var _this2$uploader;

          return (_this2$uploader = _this2.uploader) === null || _this2$uploader === void 0 ? void 0 : _this2$uploader.click();
        },
        onRemove: function onRemove() {
          return _onChange({
            logoUrl: ''
          });
        }
      })), (0, _preact.h)(_ImageUploader.default // eslint-disable-next-line @typescript-eslint/naming-convention
      , {
        onUploaded: function onUploaded(_ref) {
          var source_thumb = _ref.source_thumb;
          return _onChange({
            logoUrl: source_thumb
          });
        },
        uploaderRef: function uploaderRef(ref) {
          _this2.uploader = ref;
        }
      }), (0, _preact.h)("div", {
        className: "default-header_url-labels"
      }, (0, _preact.h)(_InputGroup.default, {
        title: "URL Label",
        meta: "Define the label for the outgoing link",
        qaClasses: "default-header_url-label",
        type: "text",
        onChange: function onChange(event) {
          return _onChange({
            label: event.target.value
          });
        },
        value: label
      }), (0, _preact.h)(_InputGroup.default, {
        title: "URL Label (mobile)",
        meta: "Define the label for the outgoing link for mobile viewports",
        qaClasses: "default-header_url--mobile-label",
        type: "text",
        onChange: function onChange(event) {
          return _onChange({
            labelMobile: event.target.value
          });
        },
        value: labelMobile
      })), (0, _preact.h)("div", {
        className: "default-header_url"
      }, (0, _preact.h)(_InputGroup.default, {
        title: "URL",
        meta: "Define the URL for the outgoing link",
        qaClasses: "default-header_url",
        type: "text",
        onChange: function onChange(event) {
          return _onChange({
            url: event.target.value
          });
        },
        value: url
      })), (0, _preact.h)("div", {
        className: "default-header_colors"
      }, (0, _preact.h)(_ColorSelector.default, {
        title: "Background Color",
        className: "default-header_background_color",
        meta: "Define the background color for the community header",
        selectedColor: backgroundColor,
        onCallback: function onCallback(backgroundColor) {
          return _onChange({
            backgroundColor: backgroundColor
          });
        }
      }), (0, _preact.h)(_ColorSelector.default, {
        title: "Link Color",
        className: "default-header_text_color",
        meta: "Define the text color of the link to the website",
        selectedColor: linkColor,
        onCallback: function onCallback(linkColor) {
          return _onChange({
            linkColor: linkColor
          });
        }
      })));
    }
  }]);
  return DefaultHeader;
}(_preact.Component);

var _default = DefaultHeader;
exports.default = _default;